import check from "check-types";

const stringifyValue = (value) =>
  Array.isArray(value) ? value.map(String).join(" ") : value;

const formatEntries = (obj) =>
  Object.entries(obj).map(([label, value]) => {
    const v = stringifyValue(value);
    return `${label.replace(/_/g, " ").toUpperCase()}: ${v}`;
  });

const filterError = (errors) => {
  try {
    if (!errors || typeof errors !== "object") return [];

    // 401s are handled by the axios interceptor (token refresh); no message.
    if (errors.response && errors.response.status === 401) return [];

    const data = errors.response && errors.response.data;

    if (!data) return ["No network connectivity or Unknown error"];
    if (typeof data === "string") return [data];

    const { errors: err, detail, msg } = data;

    if (typeof err === "string") return [err];
    if (detail) return [String(detail)];
    if (typeof msg === "string") return [msg];
    if (Array.isArray(msg)) return msg.map((m) => String(m));
    if (Array.isArray(err)) return err.map(String);
    if (check.object(err)) return formatEntries(err);

    // Flat validation body, e.g. { account_no: "already exists" }
    if (check.object(data)) return formatEntries(data);

    return [];
  } catch (error) {
    return [];
  }
};

export default filterError;
